<template>
    <div class="raw-html-page">
        <SanitizedHtml
            v-if="page"
            :content="page.html"
            :attributeWhitelist="attributeWhitelist"
            :style="{ 'width': fullWidth ? '100%' : 'unset' }"
        />
    </div>
</template>

<script>
    import { SanitizedHtml } from '@superbet-group/web.lib.ui-components';

    import { setDocumentTitle } from '@/app/utils/metaTags';

    export default {
        name: 'HtmlPage',
        props: {
            page: {
                type: Object,
                required: true,
            },
            fullWidth: {
                type: Boolean,
                default: false,
            },
            attributeWhitelist: {
                type: Array,
                default: () => [],
            },
        },
        watch: {
            page: {
                handler(value) {
                    if (value && value.title) {
                        setDocumentTitle(value.title);
                    }
                },
                immediate: true,
            },
        },
        components: {
            SanitizedHtml,
        },
    };
</script>
